import React, { FC }               from "react";
import { DropdownItemProps, Form } from "semantic-ui-react";
import GenderType                  from "../../../domain/fundamentals/gender/GenderType";

interface Props {
  genderType: GenderType;
  onChange: (genderType: GenderType) => void;
  disabled?: boolean;
}

const GenderSelector: FC<Props> = (props: Props) => {
  const options: DropdownItemProps[] = [
    {
      key: GenderType.NOT_KNOWN,
      text: "未選択",
      value: GenderType.NOT_KNOWN,
    },
    {
      key: GenderType.MALE,
      text: "男性",
      value: GenderType.MALE,
    },
    {
      key: GenderType.FEMALE,
      text: "女性",
      value: GenderType.FEMALE,
    },
    {
      key: GenderType.NOT_APPLICABLE,
      text: "その他",
      value: GenderType.NOT_APPLICABLE,
    },
  ];
  return (
    <>
      <Form.Field>
        <label>性別</label>
        <Form.Dropdown
          selection
          options={ options }
          value={ props.genderType }
          disabled={ props.disabled }
          onChange={ (event, data) => props.onChange(selectGender(data.value)) }
        />
      </Form.Field>
    </>
  )
};

const selectGender = (value: any): GenderType => {
  switch (value) {
    default:
      return GenderType.NOT_KNOWN;
    case GenderType.MALE:
      return GenderType.MALE;
    case GenderType.FEMALE:
      return GenderType.FEMALE;
    case GenderType.NOT_APPLICABLE:
      return GenderType.NOT_APPLICABLE;
  }
};

export default GenderSelector;
